<!-- 主播管理-->
<template>
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="anchor_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>

    <!-- 修改主播信息 -->
    <a-modal
      :width="editType === '1' ? 900 : 520"
      :title="moduleTitle"
      :visible="visible"
      :footer="null"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      v-if="editType === '1'"
      apiOrigin="PHP"
      ref="form"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
    <div class="radio-box" v-else>
  <a-checkbox-group @change="onChange" v-model="checkedValues" :value="checkedValues">
    <a-row>
      <a-col v-for="item in powerList" :key="item.label">
        <a-checkbox :value="item.value" style="margin-top:16px;">
          {{item.label}}
        </a-checkbox>
      </a-col>
    </a-row>
    <a-button
      @click="handleClick"
      type="primary"
      :loading="btnLoading.loading"
      style="margin-top: 20px;"
    >
    确定
    </a-button>
  </a-checkbox-group>
    </div>
    </a-modal>
  </div>
</template>

<script>
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  name: 'anchorManage',
  mixins: [addEdit],
  data () {
    return {
      moduleTitle: '新增主播',
      visible: false,
      radioValue: '',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      editType: '1',
      btnLoading: { loading: false },
      powerList: [],
      checkedValues: [],
      currentRow: {},
      searchList: [
        { props: ['keywords'], placeholder: '主播昵称', options: [], inputType: 'input' },
        { props: ['user_type'], placeholder: '类型', options: [], inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', handle: () => this.openModel(null, '1'), permi: ['community:anchorManage:add'] }
      ],
      rowOptList: [
        { text: '编辑', handle: (row) => this.openModel(row, '1'), permi: ['community:anchorManage:edit'] },
        { text: '标签管理', handle: (row) => this.goToLabel(row), permi: ['community:anchorManage:label'] },
        { text: '权限管理', handle: (row) => this.openModel(row, '2'), permi: ['community:anchorManage:power'] },

        [
          { text: '直播记录', handle: (row) => this.goToRecord(row), permi: ['community:anchorManage:record'] },
          { text: '主播资料', handle: (row) => this.goToMeans(row), permi: ['community:anchorManage:means'] }
        ]
      ],
      columns: [
        { title: 'memberID', dataIndex: 'uid', align: 'left', width: '' },
        { title: 'userID', dataIndex: 'chat_account', align: 'left', width: '' },
        { title: '主播昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'user_type_desc', align: 'left', width: '' },
        { title: '认证方式', dataIndex: 'auth_type_txt', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        user_type: undefined
      },
      listApi: {
        url: 'live/anchors', //
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      formList: [
        {
          label: '身份证正面',
          inputType: 'upload',
          options: [],
          placeholder: '',
          extra: '',
          fileList: [],
          uploadParam: {
            url: '/oss_upload/1',
            iconUrl: 'idcard_image',
            iconName: 'file_name',

            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['file_id', {
            rules: [{required: true, message: '请选择身份证正面照'}]
          }]
        },
        {
          isShow: false,
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          props: ['mobile', {
            rules: [
              { required: true, message: '请输入手机号' },
              { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
            ]
          }]
        },
        {
          label: '姓名',
          inputType: 'input',
          options: [],
          placeholder: '请输入姓名',
          props: ['true_name', {
            rules: [
              { required: true, message: '请输入姓名' }
            ]
          }]
        },
        {
          label: '身份证号',
          inputType: 'input',
          options: [],
          placeholder: '请输入身份证号',
          props: ['idcard', {
            rules: [
              { required: true, message: '请输入身份证号' }
            ]
          }]
        }
      ],
      formKey: {
        file_id: '',
        mobile: '',
        true_name: '',
        idcard: ''
      },
      addParam: {
        url: '/live/anchors',
        reqHandle: this.addReqHandle,
        resHandle: this.editResHandle // this.addResHandle
      },
      editParam: {
        url: '/live/anchors/',
        reqHandle: this.addReqHandle,
        resHandle: this.editResHandle // this.editResHandle
      },
      detailParam: {
        url: '/live/anchors',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
  },
  methods: {
    getSelect () {
      this._get({
        url: '/live/anchors/selectlist'
      }).then(res => {
        this.searchList[1].options = res.data.user_type;
        this.powerList = res.data.auths;
      });
    },
    openModel (row, type) {
      this.editType = type;
      this.visible = true;
      this.$nextTick(() => {
        this.removeFile('file_id');
      });
      if (this.editType === '1') {
        if (row) {
          this.detailParam.url = `/live/anchors/${row.anchor_id}`;
          // let url = `/live/anchors/${row.anchor_id}`;
          this.$nextTick(() => {
            this.$refs.form.getDetail();
            this.$refs.form.routeQuery = row.anchor_id;
          });
          this.moduleTitle = '编辑主播';
          this.formList[1].isShow = false;
        } else {
          this.formList[1].isShow = true;
          this.moduleTitle = '新增主播';
        }
      } else {
        this.currentRow = row;
        this.checkedValues = row.auths;
        this.checkedValues = this.checkedValues.map(item => {
          return Number(item);
        });
        this.moduleTitle = '权限管理';
      }
    },
    onChange (checkedValues) {
      this.checkedValues = checkedValues;
    },
    handleClick () {
      this._post({
        url: `/live/anchors/${this.currentRow.anchor_id}/auths`,
        params: {
          auths: this.checkedValues.length ? this.checkedValues.join(',') : ''
        }
      }).then(res => {
        if (res.code === 1) {
          this.visible = false;
          this.$message.success(res.msg);
          this.$refs.table.getTableList();
        }
      });
    },
    goToLabel (row) {
      this.$router.push({
        name: 'anchorLabel',
        query: {id: row.anchor_id, name: row.nick_name}
      });
    },
    goToRecord (row) {
      this.$router.push({
        name: 'broadcastRecord',
        query: {id: row.anchor_id, name: row.nick_name}
      });
    },
    goToMeans (row) {
      this.$router.push({
        name: 'anchorReviewDetail',
        query: {id: row.anchor_id, isCheck: 1, title: '主播资料'}
      });
    },

    // 提交表单前
    addReqHandle (res) {
      if (Array.isArray(res.file_id.fileList)) {
        if (!res.file_id.fileList.length) {
          this.$message.error('请先上传身份证正面照');
        } else {
          return res;
        }
      } else {
        if (res.file_id) {
          return res;
        } else {
          this.$message.error('请先上传身份证正面照');
        }
      }
    },
    editResHandle (res) {
      if (res.code === 1) {
        this.visible = false;
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
      } else {
        this.$message.error(res.msg);
      }
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>

<style scoped>
.radio-box{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
